import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const PElement = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  return (
    <p className="element-p" style={style}>
      {replaceTemplates(element.text)}
    </p>
  );
};

export default PElement;

